import { Link } from 'react-router'
import { Avatar, Button, Icon } from '@/design-system'
import { Logo } from '@/app/Logo'
import { NotificationsPanel } from '@/features/notifications/NotificationsPanel'
import { SearchDialog } from '@/features/search/SearchDialog'
import type { User } from '@/data/types'
import { BRAND } from '@/brand/brand'
import styles from './Topbar.module.css'

export function Topbar({
  user,
  onOpenMenu,
}: {
  readonly user: User | undefined
  readonly onOpenMenu: () => void
}) {
  const name = user ? `${user.firstName} ${user.lastName}` : BRAND.name
  return (
    <header className={styles.topbar}>
      <button type="button" className={styles.menu} onClick={onOpenMenu} aria-label="Open menu">
        <Icon name="menu" size={20} />
      </button>

      <Logo size={19} className={styles.brandMobile} />

      <div className={styles.spacer} />

      <SearchDialog />
      <NotificationsPanel />

      <Button variant="primary" size="md" iconStart="add" className="pb-hide-sm" to="/add-money">
        Add money
      </Button>

      <Link to="/profile" aria-label="Profile and security">
        <Avatar name={name} size={40} />
      </Link>
    </header>
  )
}
